/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListByValueResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'ValidReviewerByCompetency',
        },
        isRequired: true,
      },
    },
  }],
} as const;
